import { StsBackendOperation } from '../../sts-backend-operation';

/**
 * Parameters for fetching a wiring diagram image by figure code.
 */
export type FetchWiringDiagramImageParams = {
    /** The figure code identifying the wiring diagram to retrieve. */
    figureCode: string;

    /** Optional abort signal for cancellation. */
    signal?: AbortSignal;
};

/**
 * Fetch a wiring diagram image as a blob for a given figure code. Used by the electrical
 * grid lookup to display the diagram image overlay.
 */
export class FetchWiringDiagramImage extends StsBackendOperation {
    /**
     * Fetch the wiring diagram image from the API.
     *
     * @param params - the figure code identifying the diagram and optional abort signal
     * @returns the diagram image as a Blob
     */
    async exec(params: FetchWiringDiagramImageParams): Promise<Blob | undefined> {
        const { signal, ...request } = params;
        const response = await this.client.fetchWiringDiagramImage(request, signal);

        if (!response.success) {
            return undefined;
        }

        return response.data;
    }
}
